import { ComponentBase } from '../../component-base';
import * as Components from './components';
import { ComponentsList } from './ComponentsList';
import { Injectable } from '@angular/core';
import { EdgesControlsServcie } from './edges-controls.service';

interface IComponent {
  new (...args): ComponentBase;
}

@Injectable()
export class ToolSwitcher {
  constructor(private componentList: ComponentsList, private edgesCntl: EdgesControlsServcie) {}

  singleLine() {
    this.activateComponent([Components.DrawLineComponent]);
  }

  moveObject() {
    this.activateComponent([Components.MoveObjectComponent, Components.DeleteObjectComponent]);
  }

  select() {
    this.activateComponent([
      Components.SelectComponent,
      Components.MovePolylineNodes,
      Components.CircleScaleComponent,
      Components.PolyLineScaleComponent,
      Components.RectangleScaleComponent,
      Components.EditTextComponent,
      Components.DeleteObjectComponent,
      Components.CloneObjectComponent,
      Components.EditDimensionsComponent,
      Components.MoveTextArrow,
      Components.EditPostComponent,
      Components.EditPicketComponent
    ]);
  }

  polyline() {
    this.activateComponent([Components.DrawPolyLineComponent]);
  }

  arc() {
    this.activateComponent([Components.DrawArcComponent]);
  }

  circle() {
    this.activateComponent([Components.DrawCircleComponent]);
  }

  rectangle() {
    this.activateComponent([Components.DrawRectangleComponent]);
  }

  angle() {
    this.activateComponent([Components.DrawAngleComponent]);
  }

  dimensions() {
    this.activateComponent([Components.DrawDimensionsComponent]);
  }

  text() {
    this.activateComponent([Components.DrawTextComponent]);
  }

  addPost() {
    this.activateComponent([Components.AddPostComponent]);
  }

  addPicket() {
    this.activateComponent([Components.AddPicketComponent]);
  }

  addCornerPost() {
    this.activateComponent([Components.AddCornerPostComponent]);
  }

  private activateComponent(componentsToActivate: Array<IComponent>) {
    const components = this.componentList;
    let i = 0,
      component;
    let needEdges = false;
    for (; i < components.length; i++) {
      component = components[i];
      if (componentsToActivate.some(componentType => component instanceof componentType)) {
        component.enable();
      } else {
        component.disable();
      }
      if (
        (component instanceof Components.AddPostComponent ||
          component instanceof Components.AddPicketComponent) &&
        component.isEnabled()
      ) {
        needEdges = true;
      }
    }
    this.edgesCntl.setEdgesVisibility(needEdges);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/ToolSwitcher.ts